/* eslint-disable no-bitwise */
export const generateRandomColor = () => {
    const randomInt = Math.floor(Math.random() * 16777216); // 2^24 = 16777216
    const hexString = randomInt.toString(16);
    return `#${hexString.padStart(6, '0')}`;
};

export const hashStringToColor = (str?: string) => {
    let hash = 0;
    str += 'noiseynoise!@#$%^&*()_+§§1234567890-=~`{}[]|\\:";\'<>,.?/';
    // Calculate hash with added noise
    str?.split('').forEach((char, index) => {
        hash = char.charCodeAt(0) + ((hash << 6) - hash) + index;
    });

    let color = '#';
    const min = 64; // Minimum value for R, G, B to avoid dark colors
    const max = 192; // Maximum value for R, G, B to avoid bright colors

    for (let i = 0; i < 3; i++) {
        // Loop only 3 times for R, G, B values
        let value = (hash >> (i * 8)) & 255;
        value = (value ^ ((hash >> (i * 16)) & 255)) & 255; // Adding more randomness
        const adjustedValue = Math.floor((value % (max - min)) + min);
        color += adjustedValue.toString(16).padStart(2, '0');
    }

    return color;
};

export const changeColorLightness = (
    color: string,
    amount: number,
    usePound: boolean = false
) => {
    if (color.startsWith('#')) {
        color = color.slice(1);
        usePound = true;
    }

    const num = parseInt(color, 16);

    let r = (num >> 16) + amount;
    r = Math.min(255, Math.max(r, 0));

    let b = ((num >> 8) & 0x00ff) + amount;
    b = Math.min(255, Math.max(b, 0));

    let g = (num & 0x0000ff) + amount;
    g = Math.min(255, Math.max(g, 0));

    return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
};
